/** Domain of an email address (after the last '@', lowercased), or null when absent. */
export function emailDomain(email: string): string | null {
  const domain = email.slice(email.lastIndexOf('@') + 1)
  return email.includes('@') && domain ? domain.toLowerCase() : null
}

/**
 * Riga vuota tra corpo e firma (#330). Deve restare identica a
 * `SIGNATURE_SEPARATOR_HTML` in `backend/app/services/email_html.py`:
 * l'anteprima mostra lo stesso HTML dell'invio di test e dell'invio reale.
 */
export const SIGNATURE_SEPARATOR_HTML = '<p style="margin: 0">&nbsp;</p>'
